import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const canPullProduct = map.useCanPullProduct()

    if (! canPullProduct) {
        return null
    }

    return {
        key: 'pull-product',
        label: '刷新制品',
        onClick: () => map.cmdPullProduct()
    }
}
